import { useInfiniteQuery } from '@tanstack/react-query';

import { mnosQueries } from '../utils/queries';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

import { useMemo } from 'react';
import { fetchMnos } from 'src/simInventory/SimInventoryApi/mnoApi';

const MNOS_PAGE_SIZE = 100;

export const useInfinityMnosQuery = (
  searchText: string,
  options?: { enabled?: boolean; minTime?: number },
) => {
  const enabled = options?.enabled ?? true;
  const minTime = options?.minTime ?? 0;

  const { data, ...queryProps } = useInfiniteQuery({
    queryKey: mnosQueries.infinityList({ search: searchText, pageSize: MNOS_PAGE_SIZE }),
    queryFn: async ({ pageParam }) => {
      if (minTime > 0) {
        return setMinimalPromiseTime(
          fetchMnos({
            search: searchText,
            pageSize: MNOS_PAGE_SIZE,
            pageNumber: pageParam,
          }),
          minTime,
        );
      }

      return fetchMnos({
        search: searchText,
        pageSize: MNOS_PAGE_SIZE,
        pageNumber: pageParam,
      });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.length >= MNOS_PAGE_SIZE) {
        return pages.length + 1;
      }
    },

    enabled,
  });

  const mnos = useMemo(
    () =>
      data?.pages.reduce((acc, value) => {
        return [...acc, ...value];
      }, []) || [],
    [data],
  );

  return {
    mnos,
    ...queryProps,
  };
};
